<template>
  <div>
    <h1>"If there's a way to do it better, find it."</h1>
    <h2>Thomas A. Edison</h2>
    <h4>At RadixGeo we use analytics and machine learning to provide solutions to the oil and gas and mining sectors.</h4>
  </div>
  
</template>

<script>

export default {
  name: 'Quote',
  components: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url('https://fonts.googleapis.com/css?family=KoHo:500&display=swap');

h1, h2, h4 {
  font-family: 'Koho', sans-serif;
  color: white;
  text-shadow: 1px 1px #000;
  position: relative;
}

h1 {
  font-size: 4rem;
  padding: 2rem;
  text-align: center;
}

h2 {
  padding: 0 2rem;
  font-size: 3.5rem;
  text-align: center;
}

h4 {
  padding: 3rem 2rem;
  font-size: 2.2rem;
  text-align: left;
}

h1, h2 {
    -webkit-animation: fadein 5s; /* Safari, Chrome and Opera > 12.1 */
   -moz-animation: fadein 5s; /* Firefox < 16 */
    -ms-animation: fadein 5s; /* Internet Explorer */
     -o-animation: fadein 5s; /* Opera < 12.1 */
        animation: fadein 5s;
}

@keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Firefox < 16 */
@-moz-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Safari, Chrome and Opera > 12.1 */
@-webkit-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
/* ::-webkit-scrollbar{width:2px;height:2px;}
::-webkit-scrollbar-button{width:2px;height:2px;} */

/* Internet Explorer */
@-ms-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}

/* Opera < 12.1 */
@-o-keyframes fadein {
    from { opacity: 0; }
    to   { opacity: 1; }
}
</style>
